import { render, staticRenderFns } from "./tobbar.vue?vue&type=template&id=74365d3f&scoped=true&"
import script from "./tobbar.vue?vue&type=script&lang=js&"
export * from "./tobbar.vue?vue&type=script&lang=js&"
import style0 from "./tobbar.vue?vue&type=style&index=0&id=74365d3f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74365d3f",
  null
  
)

export default component.exports